<script lang="ts">
  import Select from 'svelte-select/Select.svelte';
  import { _ } from 'svelte-i18n';

  // Props
  export let open: boolean = false;
  export let inputValue: string = '';
  export let submitFunction: () => void;
  export let submitButtonText: string = 'Confirm';

  // Internal state
  interface RejectionOption {
    id: number;
    value: string;
    label: string;
  }

  const collection: RejectionOption[] = [
    { id: 0, value: 'custom', label: 'Custom rejection reason' },
    {
      id: 1,
      value: 'incorrect-receipt',
      label: 'Incorrect purchase receipt (invoice)',
    },
    {
      id: 2,
      value: 'not-mercedes-dealership',
      label: 'Not bought at Mercedes dealership',
    },
    {
      id: 3,
      value: 'incorrect-wheels',
      label: 'Incorrect wheels (QA numbers) and amount of wheels',
    },
    { id: 4, value: 'not-mounted', label: 'Not mounted / Montage' },
    { id: 5, value: 'not-stored', label: 'Not stored / Einlagerung' },
  ];

  let selectedValue: RejectionOption | null = collection[0];

  // Keep inputValue in sync when predefined option selected
  $: if (selectedValue && selectedValue.id !== 0) {
    inputValue = selectedValue.label;
  }

  function handleClear() {
    selectedValue = null;
    inputValue = '';
  }

  function handleSubmit() {
    submitFunction?.();
    open = false;
  }

  function handleClose() {
    open = false;
    selectedValue = collection[0];
    inputValue = '';
  }

  function handleKeyDown(event: KeyboardEvent) {
    if (open && event.key === 'Escape') {
      handleClose();
    }
  }
</script>

<svelte:window on:keydown={handleKeyDown} />


{#if open}
  <div
    class="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-500/75"
  >
    <form
      class="relative w-full max-w-lg transform rounded bg-white shadow-xl transition-all"
      on:submit|preventDefault={handleSubmit}
    >
      <!-- Header -->
      <div class="flex items-center justify-between border-b px-6 py-4">
        <h3 class="text-lg font-semibold text-slate-900">Rejection reason</h3>
        <button type="button" class="close-btn" on:click={handleClose}>✕</button
        >
      </div>

      <!-- Body -->
      <div class="flex flex-col gap-4 px-6 py-4">
        <Select
          items={collection}
          bind:value={selectedValue}
          container="body"
          clearable={true}
          on:clear={handleClear}
        />

        {#if selectedValue?.id === 0}
          <input
            type="text"
            name="rejectionReason"
            bind:value={inputValue}
            placeholder="Enter custom rejection reason"
            class="modal-input"
          />
        {/if}
      </div>

      <!-- Footer -->
      <div class="flex justify-end border-t bg-slate-50 px-6 py-3">
        <button
          type="submit"
          class="inline-flex items-center justify-center rounded border border-transparent bg-primary px-4 py-2 text-sm font-semibold text-white shadow-sm transition-all hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2 active:shadow-none"
        >
          {$_(submitButtonText)}
        </button>
      </div>
    </form>
  </div>
{/if}

<style>
  .close-btn {
    background: none;
    border: none;
    font-size: 20px;
    color: #6b7280;
    cursor: pointer;
    transition: color 0.2s;
  }
  .close-btn:hover {
    color: #111827;
  }

  .modal-input {
    width: 100%;
    border-radius: 8px;
    border: 1px solid #d1d5db;
    padding: 10px;
    font-size: 0.95rem;
  }
  .modal-input:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 1px #2563eb;
  }
</style>
